import React, { FC } from 'react';
import Subheading from '../font/Subheading';

import Row from '../layout/Row';
import ColumnItem from '../layout/ColumnItem';
import SectionContainer from './SectionContainer';
import Spacer from '../layout/Spacer';
import RadioButtonWrapper from '../radio/RadioButtonWrapper';
import RadioButton from '../radio/RadioButton';
import RadioButtonContent from '../radio/RadioButtonContent';
import { useAppSelector, useAppDispatch } from '../../redux/redux.hooks';
import { changeLengthUnit } from '../../reducers/fit.quiz.widget.reducer';
import { PreviewContainer } from './PreviewContainer';
import { P } from '../font/Parargraph';

type CmToInchesProps = {};

const CmToInches: FC<CmToInchesProps> = () => {
  const { data } = useAppSelector((state) => state.widgetReducer);
  const dispatch = useAppDispatch();
  const renderSetting = () => (
    <>
      <Row>
        <ColumnItem>
          <s-heading fontSize='large'>Unit of measuring length</s-heading>
          <Spacer height={8} />
          <P>Set which unit of measurement should be highlighted</P>
        </ColumnItem>
      </Row>
      <Spacer height={24} />
      <Row>
        <ColumnItem>
          <Subheading>UNIT FOR LENGTH</Subheading>
          <Spacer height={8} />
          <Row>
            <RadioButtonWrapper>
              <RadioButton
                groupName='length'
                value='cm'
                checked={data.lengthUnit === 'cm'}
                onClick={() => dispatch(changeLengthUnit('cm'))}
                content={() => <RadioButtonContent>CM</RadioButtonContent>}
              />
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                groupName='length'
                value='inches'
                checked={data.lengthUnit === 'inches'}
                onClick={() => dispatch(changeLengthUnit('inches'))}
                content={() => <RadioButtonContent>INCHES</RadioButtonContent>}
              />
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                groupName='length'
                value='remove-cm'
                checked={data.lengthUnit === 'remove-cm'}
                onClick={() => dispatch(changeLengthUnit('remove-cm'))}
                content={() => (
                  <RadioButtonContent>REMOVE CM</RadioButtonContent>
                )}
              />
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                groupName='length'
                value='remove-inches'
                checked={data.lengthUnit === 'remove-inches'}
                onClick={() => dispatch(changeLengthUnit('remove-inches'))}
                content={() => (
                  <RadioButtonContent>REMOVE INCHES</RadioButtonContent>
                )}
              />
            </RadioButtonWrapper>
          </Row>
        </ColumnItem>
      </Row>
    </>
  );
  let cmStyle;
  let inchStyle;
  const renderPreview = () => {
    switch (data.lengthUnit) {
      case 'cm':
        cmStyle = '1.75rem';
        inchStyle = '1rem';
        break;
      case 'inches':
        cmStyle = '1rem';
        inchStyle = '1.75rem';
        break;
      case 'remove-cm':
        cmStyle = '0rem';
        inchStyle = '1.75rem';
        break;
      case 'remove-inches':
        cmStyle = '1.75rem';
        inchStyle = '0rem';
    }

    return (
      <PreviewContainer>
        <p style={{ fontSize: inchStyle }}>5ft 9 in</p>
        <Spacer height={8} />
        <p style={{ fontSize: cmStyle }}>175cm</p>
      </PreviewContainer>
    );
  };
  return (
    <SectionContainer
      renderSettingsForm={renderSetting}
      renderPreview={renderPreview}
    />
  );
};

export default CmToInches;
